import { REFRESH_TOKEN } from '@/constants/api'
import axios from 'axios'
import { isNil } from 'lodash-es'
import storage from '../Storage'
import buildHost from '../request/buildHost'
import { API_HOST } from '../request/host'

let promise: Promise<{ refreshToken: string; token: string }> | null = null
export async function refreshTokens(refreshToken = storage.auth.refreshToken) {
	if (isNil(refreshToken)) {
		throw new Error('No valid refreshToken')
	}
	promise =
		promise ??
		axios
			.post(
				REFRESH_TOKEN,
				{},
				{
					baseURL: buildHost(API_HOST),
					headers: {
						'x-jike-refresh-token': refreshToken,
					},
				}
			)
			.then((res) => res.data)
			.then((data) => ({
				token: data['x-jike-access-token'],
				refreshToken: data['x-jike-refresh-token'],
			}))
			.then((tokens) => {
				storage.auth.token = tokens.token
				storage.auth.refreshToken = tokens.refreshToken
				return tokens
			})
			.finally(() => {
				promise = null
			})
	return promise
}

export function getLoginQRCodeURL(uuid: string | undefined) {
	if (!uuid) {
		return null
	}

	const encodedURI = encodeURIComponent(`https://www.okjike.com/account/scan?uuid=${uuid}`)
	const url = `jike://page.jk/web?url=${encodedURI}&displayHeader=false&displayFooter=false`
	return url
}
